

const SET_RECOMMEND_PRODUCT = (state, product) => {
  state.product = product;
};


export default {
  SET_RECOMMEND_PRODUCT
};




// WEBPACK FOOTER //
// ./src/store/modules/reserved/recommend/mutations.js